import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const YearContainer = styled.div`
  @media (max-width: 450px) {
    border-bottom: 1px solid rgb(245,245,245);
    padding-bottom: 2rem;
  }
`;

const PctContainer = styled.div`
  display: block;
  width: 100%;
  height: 10px;
  background-color: #eae4e4;
  margin: 1rem 0 1rem;
  position: relative;
  border-radius: 2px;
  @media (max-width: 450px) {
    width: 70%;
    margin: 1rem auto;
  }
`;

const PctBlock = styled.div`
  display: block;
  background-color: #d42d24;
  position: absolute;
  height: 10px;
  text-align: center;
  p {
    font-size: 0.875rem;
    position: absolute;
    transform: translate(-50%, -100%);
    text-align: center;
    left: 50%;
  }
`;

const YearLabel = styled.h6`
  font-size: 1rem;
  text-align: center;
  margin-bottom: 0.5rem;
`;

const HrLabel = styled.p`
  font-size: 0.75rem;
  line-height: 1rem;
  text-align: center;
  margin-bottom: 0.25rem;
  text-transform: uppercase;
`;

const HrMarker = styled.span`
  width: 10px;
  height: 10px;
  margin-right: 3px;
  margin-bottom: 3px;
  display: inline-block;
  border-radius: 50%;
  float: left;
  &.hr__marker-one {
    background-color: rgba(89,136,157,0.25);
    border: 1px solid rgba(89,136,157,1);
  }
  &.hr__marker-two {
    background-color: rgba(157,186,115,0.25);
    border: 1px solid rgba(157,186,115,1);
  }
  &.hr__marker-three {
    background-color: rgba(250,186,84,0.25);
    border: 1px solid rgba(250,186,84,1);
  }
  &.hr__marker-four {
    background-color: rgba(234,33,45,0.25);
    border: 1px solid rgba(234,33,45,1);
  }
`;

const HrContainer = styled.div`
  margin-bottom: 0.25rem;
  &:after {
    clear: both;
    display: table;
    content: '';
  }
  @media (max-width: 450px) {
    width: 70%;
    margin: 0 auto 0.25rem;
  }
`;

const OrtizYear = ({ data, image }) => {
  let oneRunCount = [];
  let twoRunCount = [];
  let threeRunCount = [];
  let fourRunCount = [];

  if (data.oneRun > 0) {
    for (let i = 1; i <= data.oneRun; i += 1) {
      oneRunCount.push(<HrMarker key={`${data.year}-one-run-${i}`} className="hr__marker hr__marker-one" />);
    }
  } else {
    oneRunCount = null;
  }

  if (data.twoRun > 0) {
    for (let i = 1; i <= data.twoRun; i += 1) {
      twoRunCount.push(<HrMarker key={`${data.year}-two-run-${i}`} className="hr__marker hr__marker-two" />);
    }
  } else {
    twoRunCount = null;
  }

  if (data.threeRun > 0) {
    for (let i = 1; i <= data.threeRun; i += 1) {
      threeRunCount.push(<HrMarker key={`${data.year}-three-run-${i}`} className="hr__marker hr__marker-three" />);
    }
  } else {
    threeRunCount = null;
  }

  if (data.grandSlam > 0) {
    for (let i = 1; i <= data.grandSlam; i += 1) {
      fourRunCount.push(<HrMarker key={`${data.year}-four-run-${i}`} className="hr__marker hr__marker-four" />);
    }
  } else {
    fourRunCount = null;
  }

  return (
    <YearContainer className="ortiz-year">
      <img src={image} alt={`${data.year} home run graphic`} />
      <YearLabel className="bentonsanscond-n4 year__year">{data.year} - {data.team}</YearLabel>
      <HrLabel className="bentonsanscond-n4">Total</HrLabel>
      <PctContainer className="year__pct-container">
        <PctBlock
          className="year__pct"
          style={{ width: `${data.pct}%`, left: `${data.pctBefore}%` }}
        >
          <p className="bentonsanscond-n4">{data.total}</p>
        </PctBlock>
      </PctContainer>
      <HrContainer>
        <HrLabel className="bentonsanscond-n4">By type</HrLabel>
        {oneRunCount}
        {twoRunCount}
        {threeRunCount}
        {fourRunCount}
      </HrContainer>
    </YearContainer>
  );
};

export default OrtizYear;

OrtizYear.propTypes = {
  data: PropTypes.shape({
    year: PropTypes.number,
    team: PropTypes.string,
    total: PropTypes.number,
    totalBefore: PropTypes.number,
    pct: PropTypes.number,
    pctBefore: PropTypes.number,
    oneRun: PropTypes.number,
    twoRun: PropTypes.number,
    threeRun: PropTypes.number,
    grandSlam: PropTypes.number,
    wpa: PropTypes.number,
    wpaPerHR: PropTypes.number,
  }).isRequired,
  image: PropTypes.string.isRequired,
};
